import { render, staticRenderFns } from "./EmptyPageComponent.vue?vue&type=template&id=187410f6&"
import script from "./EmptyPageComponent.vue?vue&type=script&lang=js&"
export * from "./EmptyPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./EmptyPageComponent.vue?vue&type=style&index=0&id=187410f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports